import api from 'api';

export const loadSkanSchemes = api('GET /api/skan-schemes/grid');

export const loadSkanSchemeHistory = api('GET /api/skan-schemes/:id/history');

export const exportSkanScheme = api('POST /api/skan-schemes/:id/export', {
  responseType: 'blob',
});

export const exportdHistorySkanScheme = api(
  'POST /api/skan-schemes/history/:id/export',
  {
    responseType: 'blob',
  }
);
